import { useTranslation } from 'react-i18next';

export default function FinalCta({ onCta }) {
  const { t } = useTranslation();

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-brand-600 to-accent-600 text-white">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl font-display font-bold leading-tight">
          {t('landing.finalCta.title')}
          <br />
          <span className="text-yellow-300">{t('landing.finalCta.titleHighlight')}</span>
        </h2>
        <button
          onClick={onCta}
          className="mt-10 bg-white text-brand-700 font-bold text-lg py-4 px-10 rounded-xl
                     hover:bg-gray-100 transition-all active:scale-[0.98] shadow-lg"
        >
          {t('landing.finalCta.cta')}
        </button>
      </div>
    </section>
  );
}
